import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=c7fe4586&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=c7fe4586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fe4586",
  null
  
)

export default component.exports